import { Box, Button, Image,} from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "hooks/store/hooks";
import { useTranslation } from "TranslationContext";
import React, { useEffect, useState } from "react";
import {
  markUI,
  selectColorThemeMode,
  selectIsSidebarOpen,
  toggleSidebar,
} from "stores/ui/uiSlice";
import BackArrowIcon from "components/Icons/TobarIcons/BackArrowIcon";
import LanguageDropDown from "./LanguageDropDown";
import UserIconDropDown from "./UserIconDropDown";
import BatteryIconDropDown from "./BatteryIconDropDown";
import NetworkIconDropDown from "./NetworkIconDropDown";
import WifiIconDropDown from "./WifiIconDropDown";
import GPSIconDropDown from "./GPSIconDropDown";
// import AppIcon from "components/Icons/AppIcon";
import DotsMenuIcon from "components/Icons/TobarIcons/DotsMenuIcon";
import DeviceSelectionModal from "./DeviceSelectionModal";
import apiHelper from "services/apiHelper";
import { markAuthStore, selectCurrentDevice } from "stores/auth/authSlice";
import {
  getCurrentDeviceDetails,
  getTempCurrentDeviceDetails,
  setCurrentDeviceStatusSettings,
} from "utils/local-storage";
import GiftPage from "./GiftPage";
import { useNavigate, useSearchParams,useLocation } from "react-router-dom";
import { excludedViews,isexcludedpathname } from "configs/common";
import { useDeviceDetection } from "utils/misc";
import TopQuickAccessBar from "./TopQuickAccessBar";

const Topbar = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const [searchParams] = useSearchParams();
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const isSidebarOpen = useAppSelector(selectIsSidebarOpen);
  // const [isDesktop] = useMediaQuery("(min-width: 768px)");
  const [mobileTopbarPart2, setMobileTopbarPart2] = useState(false);
  const currentDevice = useAppSelector(selectCurrentDevice);
  const localCurrentDevice = getCurrentDeviceDetails();
  const localTempCurrentDevice = getTempCurrentDeviceDetails();
  const { isDesktop, orientation } = useDeviceDetection();
  const { pathname } = useLocation();

  const shouldRenderHeader = (!excludedViews.includes(searchParams.get("view")) && !isexcludedpathname.includes(pathname)) 
        || localCurrentDevice?.family === 12;
 
  // useEffect to fetch device status information for the locally stored device
  useEffect(() => {
    if (localCurrentDevice && localCurrentDevice.imei) {
      // API call to fetch device status using IMEI number
      apiHelper(`api/device_status/deviceinfo/${localCurrentDevice.imei}`, "get", null, {})
        .then((res) => {
          // Dispatching the received device status settings to the Redux store
          dispatch(
            markAuthStore({
              currentDeviceStatusSettings: res.data.data,
              isvoiprecord: res.data.data.device_settings.isvoiprecord, // Storing VoIP recording setting
              phtonfailpin: res.data.data.device_settings.phtonfailpin === 1, // Converting pin failure flag to boolean
              deviceType: res.data.data.device_status?.osType || "", // Storing OS type
            })
          );
        })
        .catch((err) => {
          console.error(err);;
          // If an error occurs, disable the app in the Redux store
          dispatch(
            markAuthStore({
              appDisable: true,
            })
          );
          // Redirect the user to the subscription page if status is 402 (payment required)
          if (err?.response?.data?.status === 402) {
            navigate("/subscription");
          }
        });
    }
  }, []); // Runs only once when the component mounts

  // useEffect to check if the selected device has changed and fetch updated status if needed
  useEffect(() => {
    if (currentDevice && currentDevice.imei) {
      // If the temporary stored device's IMEI is different from the current device's IMEI, fetch new data
      if (localTempCurrentDevice.imei !== currentDevice.imei) {
        apiHelper(`api/device_status/deviceinfo/${currentDevice.imei}`, "get", null, {})
          .then((res) => {
            // Update the local state with the new device status settings
            setCurrentDeviceStatusSettings(res.data.data);
            // Dispatch the new device status to Redux
            dispatch(
              markAuthStore({
                currentDeviceStatusSettings: res.data.data,
                isvoiprecord: res.data.data.device_settings.isvoiprecord,
                phtonfailpin: res.data.data.device_settings.phtonfailpin === 1,
                deviceType: res.data.data.device_status?.osType || "",
              })
            );
          })
          .catch((err) => {
            console.error(err);;
            // Redirect the user to the subscription page if status is 402
            if (err?.response?.data?.status === 402) {
              navigate("/subscription");
            }
          });
      }
    }
  }, [currentDevice]); // Runs whenever `currentDevice` changes

  return (
    <>
      {isDesktop === 'computer' ? (
        <>
          <Box
            borderBottom={"1px solid #eee"}
            bg={`${colorThemeMode}_theme_gradient`}
            p={"0px 0px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            h={"50px"}
          >
            <Box display={"flex"} justifyContent={"flex-start"}>
              <Button
                h={"50px"}
                p={"0px"}
                onClick={() => {
                  dispatch(toggleSidebar());
                }}
                bgGradient={"transparent"}
                transform={!isSidebarOpen ? "rotate(180deg)" : ""}
                border={"none"}
                borderRadius={"0px"}
                _hover={{ bg: "#00000020" }}
                _focus={{}}
                _active={{ bg: "secondary.500", color: "#ffffff" }}
                _disabled={{ opacity: 0.5 }}
              >
                <BackArrowIcon />
              </Button>{" "}
              {/* <Text
                alignItems={"center"}
                as={"span"}
                display={"inline-flex"}
                color={"#009efb"}
                mx={"5px"}
                cursor={"pointer"}
                onClick={() =>
                  window.open(`${URLS.ANDROID10_SETTINGS}`, "_blank")
                }
              >
                {translate["deviceinfodash_warning_installationstep1"]}
                <Image boxSize="30px" ml={"5px"} src={faqIcon} />
              </Text> */}
              <DeviceSelectionModal />
            </Box>
            <Box display={"flex"} alignItems={"center"}>
              {/* <BluetoothIconDropDown /> */}
              {/* <TopQuickAccessBar /> */}
              <GPSIconDropDown />
              <WifiIconDropDown />
              <NetworkIconDropDown translate={translate} />
              <BatteryIconDropDown />
              <UserIconDropDown translate={translate} />
              <LanguageDropDown />
              <GiftPage />
            </Box>
          </Box>
        </>
      ) : (
        <>
        {shouldRenderHeader && (
          <>
            <Box
              bg={`${colorThemeMode}_background`}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              h={"50px"}
              px={"20px"}
              position={"relative"}
            >
              <Button
                variant={"secondary"}
                p={"5px"}
                maxW={"110px"}
                minW={"0px"}
                onClick={() => {
                  dispatch(toggleSidebar());
                }}
                //transform={!isSidebarOpen ? "rotate(180deg)" : ""}
                border={"none"}
                _active={{}}
                _hover={{}}
                _focus={{}}
                color="black"
                bg={`${colorThemeMode}_tertiary`}
              >
                {/* <HamburgerMenuIcon  /> */}
                {translate["menu"]}
              </Button> {" "}
                {/* <Image src={ASSETS.LOGOS.helplogo} padding={"8px"} height={"45px"} width={"45px"} onClick={() =>
                      window.open(`${URLS.ANDROID10_SETTINGS}`, "_blank")
                    }/> */}
                  
              <DeviceSelectionModal />
              <Box
                cursor={"pointer"}
                onClick={() => {
                  setMobileTopbarPart2(!mobileTopbarPart2);
                  dispatch(
                    markUI({
                      openMobileTopbar2: !mobileTopbarPart2,
                    })
                  );
                }}
              >
                <DotsMenuIcon />
              </Box>
            </Box>
            {mobileTopbarPart2 && (
              <Box
                position={"absolute"}
                w="-webkit-fill-available"
                bg={`${colorThemeMode}_theme_gradient`}
                p={"0px 0px"}
                display={"flex"}
                justifyContent={{ base: "space-between", md: "space-evenly" }}
                alignItems={"center"}
                h={"50px"}
                zIndex={10}
                onMouseLeave={() => {
                  setMobileTopbarPart2(false);
                  dispatch(
                    markUI({
                      openMobileTopbar2: false,
                    })
                  );
                }}
              >
                <GPSIconDropDown />
                <WifiIconDropDown />
                <NetworkIconDropDown />
                <BatteryIconDropDown />
                <UserIconDropDown />
                <LanguageDropDown />
                <GiftPage />
              </Box>
            )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Topbar;
